const Builder = require('../BuilderBase');

module.exports = class MenuHeader extends Builder {
    constructor(title, properties) {
        super('menuSelection_MenuHeader', title, properties);
    }
};
